import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { el_GR, en_GB, NzI18nService } from 'ng-zorro-antd/i18n';
import { AppointmentSignalService } from 'src/app/services/appointmentSignalR.service';
import { LocaleService } from 'src/app/services/locale.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  standalone: false,
})
export class LogoutComponent {
  name?: string | null;
  surname?: string | null;
  email?: string | null;

  defaultLanguage = this.localeService.getCurrentLocale() || 'en';

  languageOptions = [
    {
      value: 'en',
      label: 'English',
      flag: '../../../../assets/images/flags/en.png',
    },
    {
      value: 'el',
      label: 'Greek',
      flag: '../../../../assets/images/flags/gr.png',
    },
  ];

  constructor(
    private readonly keycloakService: KeycloakService,
    private readonly router: Router,
    private readonly tokenService: TokenService,
    private readonly i18n: NzI18nService,
    private readonly localeService: LocaleService,
    private readonly translate: TranslateService,
    private readonly signalService: AppointmentSignalService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    this.keycloakService.getToken().then((token) => {
      if (token) {
        const base64Decoded = this.tokenService.base64UrlDecode(
          token.split('.')[1]
        );
        const payload = JSON.parse(this.tokenService.utf8Decode(base64Decoded));
        // console.log(payload);
        this.name = payload['given_name'];
        this.surname = payload['family_name'];
        this.email = payload['email'];
      }
    });
  }

  changeLanguage(selectedLanguage: string) {
    if (selectedLanguage) {
      if (selectedLanguage == 'en') {
        this.i18n.setLocale(en_GB);
      } else {
        this.i18n.setLocale(el_GR);
      }
      this.localeService.updateLocale(selectedLanguage).subscribe({
        next: () => {
          // this.translate.use(selectedLanguage);
          this.defaultLanguage = selectedLanguage == 'en' ? 'el' : 'en';
          window.location.reload(); // This will refresh the page in order to update the token of the new locale
        },
        error: (error) => {
          console.error('Error updating locale:', error);
        },
      });
    }
  }

  logout() {
    this.signalService.stopConnection(this.userService.tenantIdSub.getValue()!);
    this.keycloakService.logout(environment.APP_URL + 'login');
  }

  resetPassword() {
    this.router.navigate(['/resetPassword']);
  }
}
